import React from 'react';
import { Input } from './ui/input';

// Strip the trailing dial code from a label, e.g. "Türkiye (+90)" -> "Türkiye".
const _stripCode = (label) => String(label || '').replace(/\s*\(\+\d+\)\s*$/, '').trim();

const _RAW_PHONE_CODES = [
  { code: '+1', flag: '🇺🇸', label: 'USA / Canada (+1)' },
  { code: '+7', flag: '🇷🇺', label: 'Russia (+7)' },
  { code: '+20', flag: '🇪🇬', label: 'Egypt (+20)' },
  { code: '+27', flag: '🇿🇦', label: 'South Africa (+27)' },
  { code: '+30', flag: '🇬🇷', label: 'Greece (+30)' },
  { code: '+31', flag: '🇳🇱', label: 'Netherlands (+31)' },
  { code: '+32', flag: '🇧🇪', label: 'Belgium (+32)' },
  { code: '+33', flag: '🇫🇷', label: 'France (+33)' },
  { code: '+34', flag: '🇪🇸', label: 'Spain (+34)' },
  { code: '+36', flag: '🇭🇺', label: 'Hungary (+36)' },
  { code: '+39', flag: '🇮🇹', label: 'Italy (+39)' },
  { code: '+40', flag: '🇷🇴', label: 'Romania (+40)' },
  { code: '+41', flag: '🇨🇭', label: 'Switzerland (+41)' },
  { code: '+43', flag: '🇦🇹', label: 'Austria (+43)' },
  { code: '+44', flag: '🇬🇧', label: 'United Kingdom (+44)' },
  { code: '+45', flag: '🇩🇰', label: 'Denmark (+45)' },
  { code: '+46', flag: '🇸🇪', label: 'Sweden (+46)' },
  { code: '+47', flag: '🇳🇴', label: 'Norway (+47)' },
  { code: '+48', flag: '🇵🇱', label: 'Poland (+48)' },
  { code: '+49', flag: '🇩🇪', label: 'Germany (+49)' },
  { code: '+51', flag: '🇵🇪', label: 'Peru (+51)' },
  { code: '+52', flag: '🇲🇽', label: 'Mexico (+52)' },
  { code: '+53', flag: '🇨🇺', label: 'Cuba (+53)' },
  { code: '+54', flag: '🇦🇷', label: 'Argentina (+54)' },
  { code: '+55', flag: '🇧🇷', label: 'Brazil (+55)' },
  { code: '+56', flag: '🇨🇱', label: 'Chile (+56)' },
  { code: '+57', flag: '🇨🇴', label: 'Colombia (+57)' },
  { code: '+58', flag: '🇻🇪', label: 'Venezuela (+58)' },
  { code: '+60', flag: '🇲🇾', label: 'Malaysia (+60)' },
  { code: '+61', flag: '🇦🇺', label: 'Australia (+61)' },
  { code: '+62', flag: '🇮🇩', label: 'Indonesia (+62)' },
  { code: '+63', flag: '🇵🇭', label: 'Philippines (+63)' },
  { code: '+64', flag: '🇳🇿', label: 'New Zealand (+64)' },
  { code: '+65', flag: '🇸🇬', label: 'Singapore (+65)' },
  { code: '+66', flag: '🇹🇭', label: 'Thailand (+66)' },
  { code: '+81', flag: '🇯🇵', label: 'Japan (+81)' },
  { code: '+82', flag: '🇰🇷', label: 'South Korea (+82)' },
  { code: '+84', flag: '🇻🇳', label: 'Vietnam (+84)' },
  { code: '+86', flag: '🇨🇳', label: 'China (+86)' },
  { code: '+90', flag: '🇹🇷', label: 'Türkiye (+90)' },
  { code: '+91', flag: '🇮🇳', label: 'India (+91)' },
  { code: '+92', flag: '🇵🇰', label: 'Pakistan (+92)' },
  { code: '+93', flag: '🇦🇫', label: 'Afghanistan (+93)' },
  { code: '+94', flag: '🇱🇰', label: 'Sri Lanka (+94)' },
  { code: '+95', flag: '🇲🇲', label: 'Myanmar (+95)' },
  { code: '+98', flag: '🇮🇷', label: 'Iran (+98)' },
  { code: '+212', flag: '🇲🇦', label: 'Morocco (+212)' },
  { code: '+213', flag: '🇩🇿', label: 'Algeria (+213)' },
  { code: '+216', flag: '🇹🇳', label: 'Tunisia (+216)' },
  { code: '+218', flag: '🇱🇾', label: 'Libya (+218)' },
  { code: '+220', flag: '🇬🇲', label: 'Gambia (+220)' },
  { code: '+221', flag: '🇸🇳', label: 'Senegal (+221)' },
  { code: '+222', flag: '🇲🇷', label: 'Mauritania (+222)' },
  { code: '+223', flag: '🇲🇱', label: 'Mali (+223)' },
  { code: '+224', flag: '🇬🇳', label: 'Guinea (+224)' },
  { code: '+225', flag: '🇨🇮', label: "Côte d'Ivoire (+225)" },
  { code: '+226', flag: '🇧🇫', label: 'Burkina Faso (+226)' },
  { code: '+227', flag: '🇳🇪', label: 'Niger (+227)' },
  { code: '+228', flag: '🇹🇬', label: 'Togo (+228)' },
  { code: '+229', flag: '🇧🇯', label: 'Benin (+229)' },
  { code: '+230', flag: '🇲🇺', label: 'Mauritius (+230)' },
  { code: '+231', flag: '🇱🇷', label: 'Liberia (+231)' },
  { code: '+232', flag: '🇸🇱', label: 'Sierra Leone (+232)' },
  { code: '+233', flag: '🇬🇭', label: 'Ghana (+233)' },
  { code: '+234', flag: '🇳🇬', label: 'Nigeria (+234)' },
  { code: '+235', flag: '🇹🇩', label: 'Chad (+235)' },
  { code: '+236', flag: '🇨🇫', label: 'Central African Rep. (+236)' },
  { code: '+237', flag: '🇨🇲', label: 'Cameroon (+237)' },
  { code: '+238', flag: '🇨🇻', label: 'Cape Verde (+238)' },
  { code: '+239', flag: '🇸🇹', label: 'São Tomé & Príncipe (+239)' },
  { code: '+240', flag: '🇬🇶', label: 'Equatorial Guinea (+240)' },
  { code: '+241', flag: '🇬🇦', label: 'Gabon (+241)' },
  { code: '+242', flag: '🇨🇬', label: 'Congo (+242)' },
  { code: '+243', flag: '🇨🇩', label: 'DR Congo (+243)' },
  { code: '+244', flag: '🇦🇴', label: 'Angola (+244)' },
  { code: '+245', flag: '🇬🇼', label: 'Guinea-Bissau (+245)' },
  { code: '+246', flag: '🇩🇬', label: 'Diego Garcia (+246)' },
  { code: '+248', flag: '🇸🇨', label: 'Seychelles (+248)' },
  { code: '+249', flag: '🇸🇩', label: 'Sudan (+249)' },
  { code: '+250', flag: '🇷🇼', label: 'Rwanda (+250)' },
  { code: '+251', flag: '🇪🇹', label: 'Ethiopia (+251)' },
  { code: '+252', flag: '🇸🇴', label: 'Somalia (+252)' },
  { code: '+253', flag: '🇩🇯', label: 'Djibouti (+253)' },
  { code: '+254', flag: '🇰🇪', label: 'Kenya (+254)' },
  { code: '+255', flag: '🇹🇿', label: 'Tanzania (+255)' },
  { code: '+256', flag: '🇺🇬', label: 'Uganda (+256)' },
  { code: '+257', flag: '🇧🇮', label: 'Burundi (+257)' },
  { code: '+258', flag: '🇲🇿', label: 'Mozambique (+258)' },
  { code: '+260', flag: '🇿🇲', label: 'Zambia (+260)' },
  { code: '+261', flag: '🇲🇬', label: 'Madagascar (+261)' },
  { code: '+262', flag: '🇷🇪', label: 'Réunion (+262)' },
  { code: '+263', flag: '🇿🇼', label: 'Zimbabwe (+263)' },
  { code: '+264', flag: '🇳🇦', label: 'Namibia (+264)' },
  { code: '+265', flag: '🇲🇼', label: 'Malawi (+265)' },
  { code: '+266', flag: '🇱🇸', label: 'Lesotho (+266)' },
  { code: '+267', flag: '🇧🇼', label: 'Botswana (+267)' },
  { code: '+268', flag: '🇸🇿', label: 'Eswatini (+268)' },
  { code: '+269', flag: '🇰🇲', label: 'Comoros (+269)' },
  { code: '+290', flag: '🇸🇭', label: 'Saint Helena (+290)' },
  { code: '+291', flag: '🇪🇷', label: 'Eritrea (+291)' },
  { code: '+297', flag: '🇦🇼', label: 'Aruba (+297)' },
  { code: '+298', flag: '🇫🇴', label: 'Faroe Islands (+298)' },
  { code: '+299', flag: '🇬🇱', label: 'Greenland (+299)' },
  { code: '+350', flag: '🇬🇮', label: 'Gibraltar (+350)' },
  { code: '+351', flag: '🇵🇹', label: 'Portugal (+351)' },
  { code: '+352', flag: '🇱🇺', label: 'Luxembourg (+352)' },
  { code: '+353', flag: '🇮🇪', label: 'Ireland (+353)' },
  { code: '+354', flag: '🇮🇸', label: 'Iceland (+354)' },
  { code: '+355', flag: '🇦🇱', label: 'Albania (+355)' },
  { code: '+356', flag: '🇲🇹', label: 'Malta (+356)' },
  { code: '+357', flag: '🇨🇾', label: 'Cyprus (+357)' },
  { code: '+358', flag: '🇫🇮', label: 'Finland (+358)' },
  { code: '+359', flag: '🇧🇬', label: 'Bulgaria (+359)' },
  { code: '+370', flag: '🇱🇹', label: 'Lithuania (+370)' },
  { code: '+371', flag: '🇱🇻', label: 'Latvia (+371)' },
  { code: '+372', flag: '🇪🇪', label: 'Estonia (+372)' },
  { code: '+373', flag: '🇲🇩', label: 'Moldova (+373)' },
  { code: '+374', flag: '🇦🇲', label: 'Armenia (+374)' },
  { code: '+375', flag: '🇧🇾', label: 'Belarus (+375)' },
  { code: '+376', flag: '🇦🇩', label: 'Andorra (+376)' },
  { code: '+377', flag: '🇲🇨', label: 'Monaco (+377)' },
  { code: '+378', flag: '🇸🇲', label: 'San Marino (+378)' },
  { code: '+380', flag: '🇺🇦', label: 'Ukraine (+380)' },
  { code: '+381', flag: '🇷🇸', label: 'Serbia (+381)' },
  { code: '+382', flag: '🇲🇪', label: 'Montenegro (+382)' },
  { code: '+383', flag: '🇽🇰', label: 'Kosovo (+383)' },
  { code: '+385', flag: '🇭🇷', label: 'Croatia (+385)' },
  { code: '+386', flag: '🇸🇮', label: 'Slovenia (+386)' },
  { code: '+387', flag: '🇧🇦', label: 'Bosnia & Herzegovina (+387)' },
  { code: '+389', flag: '🇲🇰', label: 'North Macedonia (+389)' },
  { code: '+420', flag: '🇨🇿', label: 'Czech Republic (+420)' },
  { code: '+421', flag: '🇸🇰', label: 'Slovakia (+421)' },
  { code: '+423', flag: '🇱🇮', label: 'Liechtenstein (+423)' },
  { code: '+500', flag: '🇫🇰', label: 'Falkland Islands (+500)' },
  { code: '+501', flag: '🇧🇿', label: 'Belize (+501)' },
  { code: '+502', flag: '🇬🇹', label: 'Guatemala (+502)' },
  { code: '+503', flag: '🇸🇻', label: 'El Salvador (+503)' },
  { code: '+504', flag: '🇭🇳', label: 'Honduras (+504)' },
  { code: '+505', flag: '🇳🇮', label: 'Nicaragua (+505)' },
  { code: '+506', flag: '🇨🇷', label: 'Costa Rica (+506)' },
  { code: '+507', flag: '🇵🇦', label: 'Panama (+507)' },
  { code: '+509', flag: '🇭🇹', label: 'Haiti (+509)' },
  { code: '+590', flag: '🇬🇵', label: 'Guadeloupe (+590)' },
  { code: '+591', flag: '🇧🇴', label: 'Bolivia (+591)' },
  { code: '+592', flag: '🇬🇾', label: 'Guyana (+592)' },
  { code: '+593', flag: '🇪🇨', label: 'Ecuador (+593)' },
  { code: '+595', flag: '🇵🇾', label: 'Paraguay (+595)' },
  { code: '+596', flag: '🇲🇶', label: 'Martinique (+596)' },
  { code: '+597', flag: '🇸🇷', label: 'Suriname (+597)' },
  { code: '+598', flag: '🇺🇾', label: 'Uruguay (+598)' },
  { code: '+599', flag: '🇨🇼', label: 'Curaçao (+599)' },
  { code: '+670', flag: '🇹🇱', label: 'Timor-Leste (+670)' },
  { code: '+672', flag: '🇳🇫', label: 'Norfolk Island (+672)' },
  { code: '+673', flag: '🇧🇳', label: 'Brunei (+673)' },
  { code: '+674', flag: '🇳🇷', label: 'Nauru (+674)' },
  { code: '+675', flag: '🇵🇬', label: 'Papua New Guinea (+675)' },
  { code: '+676', flag: '🇹🇴', label: 'Tonga (+676)' },
  { code: '+677', flag: '🇸🇧', label: 'Solomon Islands (+677)' },
  { code: '+678', flag: '🇻🇺', label: 'Vanuatu (+678)' },
  { code: '+679', flag: '🇫🇯', label: 'Fiji (+679)' },
  { code: '+680', flag: '🇵🇼', label: 'Palau (+680)' },
  { code: '+682', flag: '🇨🇰', label: 'Cook Islands (+682)' },
  { code: '+683', flag: '🇳🇺', label: 'Niue (+683)' },
  { code: '+685', flag: '🇼🇸', label: 'Samoa (+685)' },
  { code: '+686', flag: '🇰🇮', label: 'Kiribati (+686)' },
  { code: '+687', flag: '🇳🇨', label: 'New Caledonia (+687)' },
  { code: '+688', flag: '🇹🇻', label: 'Tuvalu (+688)' },
  { code: '+689', flag: '🇵🇫', label: 'French Polynesia (+689)' },
  { code: '+690', flag: '🇹🇰', label: 'Tokelau (+690)' },
  { code: '+691', flag: '🇫🇲', label: 'Micronesia (+691)' },
  { code: '+692', flag: '🇲🇭', label: 'Marshall Islands (+692)' },
  { code: '+850', flag: '🇰🇵', label: 'North Korea (+850)' },
  { code: '+852', flag: '🇭🇰', label: 'Hong Kong (+852)' },
  { code: '+853', flag: '🇲🇴', label: 'Macau (+853)' },
  { code: '+855', flag: '🇰🇭', label: 'Cambodia (+855)' },
  { code: '+856', flag: '🇱🇦', label: 'Laos (+856)' },
  { code: '+880', flag: '🇧🇩', label: 'Bangladesh (+880)' },
  { code: '+886', flag: '🇹🇼', label: 'Taiwan (+886)' },
  { code: '+960', flag: '🇲🇻', label: 'Maldives (+960)' },
  { code: '+961', flag: '🇱🇧', label: 'Lebanon (+961)' },
  { code: '+962', flag: '🇯🇴', label: 'Jordan (+962)' },
  { code: '+963', flag: '🇸🇾', label: 'Syria (+963)' },
  { code: '+964', flag: '🇮🇶', label: 'Iraq (+964)' },
  { code: '+965', flag: '🇰🇼', label: 'Kuwait (+965)' },
  { code: '+966', flag: '🇸🇦', label: 'Saudi Arabia (+966)' },
  { code: '+967', flag: '🇾🇪', label: 'Yemen (+967)' },
  { code: '+968', flag: '🇴🇲', label: 'Oman (+968)' },
  { code: '+970', flag: '🇵🇸', label: 'Palestine (+970)' },
  { code: '+971', flag: '🇦🇪', label: 'UAE (+971)' },
  { code: '+972', flag: '🇮🇱', label: 'Israel (+972)' },
  { code: '+973', flag: '🇧🇭', label: 'Bahrain (+973)' },
  { code: '+974', flag: '🇶🇦', label: 'Qatar (+974)' },
  { code: '+975', flag: '🇧🇹', label: 'Bhutan (+975)' },
  { code: '+976', flag: '🇲🇳', label: 'Mongolia (+976)' },
  { code: '+977', flag: '🇳🇵', label: 'Nepal (+977)' },
  { code: '+992', flag: '🇹🇯', label: 'Tajikistan (+992)' },
  { code: '+993', flag: '🇹🇲', label: 'Turkmenistan (+993)' },
  { code: '+994', flag: '🇦🇿', label: 'Azerbaijan (+994)' },
  { code: '+995', flag: '🇬🇪', label: 'Georgia (+995)' },
  { code: '+996', flag: '🇰🇬', label: 'Kyrgyzstan (+996)' },
  { code: '+998', flag: '🇺🇿', label: 'Uzbekistan (+998)' },
];

// Sort everything alphabetically by country name (case/diacritic insensitive),
// then pin host country Türkiye to the top so it's always one tap away.
const _byName = (a, b) =>
  _stripCode(a.label).localeCompare(_stripCode(b.label), undefined, { sensitivity: 'base' });
const _turkiye = _RAW_PHONE_CODES.find((c) => c.code === '+90');
const _rest    = _RAW_PHONE_CODES.filter((c) => c.code !== '+90').sort(_byName);

// `country` is the bare country name (e.g. "Türkiye"), used as the leading
// text in <option> so native keyboard search by typing letters jumps to the
// matching country.
export const PHONE_CODES = (_turkiye ? [_turkiye, ..._rest] : _rest).map((c) => ({
  ...c,
  country: _stripCode(c.label),
}));

/** Phone input with flag+code dropdown and digits-only number field.
 *  - Country code dropdown is searchable (you can type to filter).
 *  - Number field allows digits only (no spaces, dashes, or letters).
 *  - Validates length 7-15 (E.164 international standard).
 */
export const PhoneInput = ({ codeValue, numberValue, onCodeChange, onNumberChange, required = false, onBlur }) => {
  const handleNumberChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 15);
    onNumberChange(digits);
  };

  const len = (numberValue || '').length;
  const isInvalid = required && (len > 0 && (len < 7 || len > 15));

  return (
    <div>
      <div className="flex gap-2">
        <select
          data-testid="phone-code-select"
          value={codeValue || '+90'}
          onChange={(e) => onCodeChange(e.target.value)}
          title={codeValue || '+90'}
          className="w-44 sm:w-52 rounded-xl border border-input bg-background px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 shrink-0"
        >
          {PHONE_CODES.map((c) => (
            <option key={c.code + c.label} value={c.code} title={c.label}>
              {c.country} {c.flag} ({c.code})
            </option>
          ))}
        </select>
        <Input
          data-testid="phone-number-input"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="5xx xxx xx xx"
          value={numberValue || ''}
          onChange={handleNumberChange}
          onBlur={onBlur}
          minLength={7}
          maxLength={15}
          required={required}
          className={`w-44 sm:w-56 rounded-xl ${isInvalid ? 'border-red-400 focus:ring-red-300' : ''}`}
        />
      </div>
      {isInvalid && (
        <p className="text-[11px] text-red-600 mt-1 font-medium">
          Telefon numarası 7–15 rakam arasında olmalıdır.
        </p>
      )}
    </div>
  );
};

/** Validate a phone number (digits only) — returns true if valid (7..15 digits). */
export const isValidPhoneDigits = (digits) => {
  const v = String(digits || '').replace(/\D/g, '');
  return v.length >= 7 && v.length <= 15;
};

export default PhoneInput;
